// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__Ed536","expanded":"styles_expanded__gQysJ"};